import { render, staticRenderFns } from "./SnowdownInventory.vue?vue&type=template&id=f2d9b9fe"
import script from "./SnowdownInventory.vue?vue&type=script&lang=js"
export * from "./SnowdownInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports